
import Vue from "vue";
import VueLazyload from 'vue-lazyload';
Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: './dist/error.png',
  loading: './wp-content/themes/fraternitytheme/assets/svg/loading.svg',
  attempt: 1,
  lazyComponent: true
});

import Buefy from "buefy";
Vue.use(Buefy);

import VueScrollactive from "vue-scrollactive";
Vue.use(VueScrollactive);

import VueObserveVisibility from 'vue-observe-visibility';
Vue.use(VueObserveVisibility);

import "./style/main.scss";
import "./scripts/navbar.js";

import Faqs from "./components/landing/Faqs.vue";

new Vue({
  el: "#app",
  data () {
    return {
      isScreen1ModalActive: false,
      isScreen4ModalActive: false,
      isOption1ModalActive: false,
      isOption2ModalActive: false,
      isOption3ModalActive: false,
      scrollPosition: null,
      show: false,
      isFrameVisible: false,
      isProgressVisible: false,
      isNavbarVisible: false,
      isTalktoaMentorActive: false,
      scrollPosition: null
    }
  },
  components: {
    Faqs
  },
  methods: {
    navVisibilityChanged (isNavbarVisible, entry) {
      this.isNavbarVisible = isNavbarVisible
      if (isNavbarVisible) {
        this.show = true
      } else {
        this.show = false
      }
    },
    progressVisibilityChanged (isProgressVisible, entry) {
      this.isProgressVisible = isProgressVisible
      if (isProgressVisible) {
        this.show = true
      } else {
        this.show = false
      }
    },
    frameVisibilityChanged (isFrameVisible, entry) {
      this.isFrameVisible = isFrameVisible
      if (isFrameVisible) {
        this.show = true
      } else {
        this.show = false
      }
    },
    updateScroll () {
      this.scrollPosition = window.scrollY;
    },
    openModal () {
      this.modalOpen = !this.modalOpen;
    }
  },

  mounted () {
    window.addEventListener("scroll", this.updateScroll);
  }
});
